import VideoGrid from './VideoGrid.vue';

export default VideoGrid;